<div class="modal-header">
  <h4 class="modal-title">Ingreso Almacen</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12 col-xs-12">
        <form
          action=""
          [formGroup]="warehouseForm"
          (ngSubmit)="registerWarehouse()"
          class="form-horizontal form-material"
          id="warehouseForm"
          novalidate
        >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="warehouseForm.controls['producto_id']"
                [controlName]="'Producto'"
              >
                <label for="producto">Producto</label>

                <ng-select
                  bindLabel="name"
                  placeholder="Selecionar producto"
                  [searchable]="true"
                  formControlName="producto_id"
                >
                  <ng-option
                    [disabled]="estado"
                    [value]="item.producto_id"
                    *ngFor="let item of products"
                  >
                  {{item.codigo}}-
                    {{ item.nombre }}
                    <strong>({{ item.unidad.abreviado }}) <span style="font-weight: 900; font-size: small;">(C. {{item.costo_prom}})</span></strong>
                  </ng-option>
                </ng-select>
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group row m-t-20">
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="warehouseForm.controls['cantidad']"
                [controlName]="'Cantidad'"
              >
                <label for="cantidad">Cantidad</label>
                <input
                  class="form-control"
                  type="number"
                  id="cantidad"
                  formControlName="cantidad"
                  placeholder="Cantidad Total"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="warehouseForm.controls['precio_compra']"
                [controlName]="'Precio'"
              >
                <label for="compra">Precio de compra</label>
                <input
                  class="form-control"
                  type="number"
                  id="compra"
                  formControlName="precio_compra"
                  placeholder="Precio de compra"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group row m-t-20">
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="warehouseForm.controls['nro_comprobante']"
                [controlName]="'Precio'"
              >
                <label for="venta">Nro Comprobante</label>
                <input
                  class="form-control"
                  type="text"
                  id="venta"
                  formControlName="nro_comprobante"
                  placeholder=""
                />
              </app-form-error-wrapper>
            </div>
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="warehouseForm.controls['fecha_ingreso']"
                [controlName]="'Fecha ingreso'"
              >
                <label for="fecha">Fecha Ingreso </label>
                <input
                  class="form-control"
                  type="date"
                  id="fecha"
                  formControlName="fecha_ingreso"
                />
              </app-form-error-wrapper>
            </div>
          </div>

          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="warehouseForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Guardar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
